import React, { useState, useCallback, useMemo } from 'react';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import * as Yup from 'yup';
import { isEmpty } from 'lodash';

import { t, parseDateString } from '~/helpers';
import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  RadioGroup,
} from '~/components/Form';

export default function SaldoCombustivelPostoPeriodo() {
  const [open, setOpen] = useState(true);
  const [post, setPost] = useState({});
  const [product, setProduct] = useState({});

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        // datahorafinal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
        produto: Yup.string().nullable().required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string().nullable().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(data, { abortEarly: false });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  const onSerializeData = useCallback((data) => ({
    ...data,
    produtostr: product.prod_descricao,
    postostr: post.poco_descricao,
  }), [product, post]);

  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="Saldo de Combustível nos Posto no Período - Data"
      //relatorio="SALDOCOMBUSTIVELPOSTOPERIODOTANQUE"
      relatorio="saldocombustivelpostoperiodo"
      initials={{
        datahorainicial,
        datahorafinal,
        formato: 'pdf',
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="produto"
        label="prod_display"
        title="Produto"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setProduct(value)}
      />

      <Autocomplete
        name="posto"
        label="poco_descricao"
        title="Posto"
        url="postosporusuario"
        unique="poco_codigo"
        getValue={(value) => setPost(value)}
      />

      <RadioGroup
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />


      {/* <RadioGroup
        row
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      /> */}
    </Report>
  )
}
